export const stagingSettings = {
    API: {
        BASE_URL: "https://app.staging.ism-hi-light.de",
        API_PATH: "/api",
    },
    MAP_PROXY_URL: {
        BASE_URL: "https://mapproxy.ism-hi-light.de",
    },
};

export default stagingSettings;
